module.exports = __webpack_public_path__ + "static/img/check.75cacf42.svg";